import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const announcementBannerEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-insight-global-configuration-announcement-banner-main" */ './main.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
